import { HubConnectionBuilder } from "@microsoft/signalr";
import { Configuration } from "Configuration";
import { App } from "Core/App";
import { BaseService } from "./BaseService";
import { BaseResult, NotificationClient } from "./Client";
import { CommandService } from "./CommandService";

export class NotificationService extends BaseService {
    init(updateFn: (count: number) => void): Promise<void> {
        let app = <App>(<any>window).app;

        const connection = new HubConnectionBuilder()
            .withUrl(Configuration.baseUrl + "/dmsnotification", { accessTokenFactory: () => app.auth.user.access_token })
            .withAutomaticReconnect()
            .build();

        connection.on("Update", (count) => {updateFn(count); });

        return connection.start();
    }

    update(): Promise<BaseResult> {
        let params = CommandService.getPageTokenParameter();
        let client = new NotificationClient(Configuration.baseUrl);
        client.beforeSend = this.getBeforeSend();

        return new Promise<BaseResult>((resolve, reject) => {
            client.sendCurrentUser(
                params,
                (res) => resolve(res),
                (exception, reason) => reject(exception)
            );
            // cancellationTokenSource.token.onCancelled((reason) => {
            //     xhr.abort();
            //     reject(reason);
            // });
        });
    }

    updateAll(): Promise<BaseResult> {
        let params = CommandService.getPageTokenParameter();
        let client = new NotificationClient(Configuration.baseUrl);
        client.beforeSend = this.getBeforeSend();

        return new Promise<BaseResult>((resolve, reject) => {
            client.sendAll(
                params,
                (res) => resolve(res),
                (exception, reason) => reject(exception)
            );
            // cancellationTokenSource.token.onCancelled((reason) => {
            //     xhr.abort();
            //     reject(reason);
            // });
        });
    }
}
